import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { UserConfig } from '../../models/user-config.model';

export const UserConfigActions = createActionGroup({
  source: 'User Config',
  events: {
    // Action dispatched by the UI to reset the view to default widths
    'Reset View': emptyProps(),
    
    // Action dispatched by the UI to update the left side container width
    'Update Left Side Container Width': props<{ width: number }>(),

    // Action dispatched by the UI to update the right side container width
    'Update Right Side Container Width': props<{ width: number }>(),
    'Update Frames Height': props<{ height: number }>(),
    'Set Canvas Hints Expanded': props<{ expanded: boolean }>(),

    // Action dispatched by the Effects to load state from IndexedDB
    'Load User Config': emptyProps(),

    // Action dispatched by the Effects once state is loaded from IndexedDB
    'Load User Config Success': props<{ userConfig: UserConfig }>(),
  },
});